import { render, staticRenderFns } from "./ChangeKennelOwnersForm1.vue?vue&type=template&id=50a087b7"
import script from "./ChangeKennelOwnersForm1.vue?vue&type=script&lang=ts"
export * from "./ChangeKennelOwnersForm1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports